import { Component, OnInit, OnDestroy } from '@angular/core';
import { DatabusService } from '../../shared/services/databus.service';
import { ValidationService } from '../../shared/services/validation.service';
import { Router } from '@angular/router';
import { Idle } from '@ng-idle/core';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss']
})
export class SuccessComponent implements OnInit {
  showModal: boolean = false;
  ticket: any;
  redeem_value: number;
  bodyUdate: HTMLElement;
  customerStatus: any;

  constructor( 
    private data: DatabusService,
    private router: Router,
    private validate: ValidationService,
    private idle: Idle ) {
      this.bodyUdate = document.getElementById('main-stage');
      this.bodyUdate.style.backgroundColor = 'rgba(40, 167, 69, 0.8)'
    }    

  Finish() {
    this.showModal = true;
  }

  ScanAnother() {
    this.router.navigate(['/scananother']);
  }

  ExtendProfile () {
    if(!this.data.password || this.data.password === '') {
      this.router.navigate(['/password']);
    } else {
      this.router.navigate(['/completeprofile']);
    }    
  }

  NoThanks () {
    this.router.navigate(['/scanticket']);
  }

  ngOnInit() {
    this.ticket = this.data.currentTicket;
    this.redeem_value = this.data.redeemValue;
    if (!this.idle.isRunning()) {
      this.idle.watch();
    };
  }

  ngOnDestroy(){
    this.bodyUdate.style.backgroundColor = 'rgba(90, 25, 114, 0.8)';
  }
}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/routes/success/success.component.ts